<template>
  <a-divider>
    磁盘
    <a-tooltip title="刷新磁盘空间" color="#2db7f5">
      <a-button type="primary" @click="initDisk" shape="circle" size="small" :icon="h(RedoOutlined)"/>
    </a-tooltip>
  </a-divider>
  <a-descriptions :column="1" v-for="(v,i) in dataServer" :key="i">
    <a-spin v-if="v.status"/>
    <template v-else>
      <a-descriptions-item v-if="v.used" :label="v.label+'服务磁盘空间'">
        <div style="display: flex;align-items: center;justify-content: center">
          <div style="width: 200px">
            <a-progress :percent="Number(v.used.match(regeNumber)[1])" :stroke-color="v.color"/>
          </div>
          <div style="margin-left: 30px;margin-top: 5px">
          <span v-for="(item,index) in v" :key="index" style="margin-left: 10px">
            <template v-if="index !== 'label' && index !== 'color' && index !== 'status'">
              {{ index }}:{{ item }}
            </template>
          </span>
          </div>
        </div>
      </a-descriptions-item>
      <a-descriptions-item :label="v.label+'服务磁盘空间'" v-else>
        <span style="color: red;margin-right: 15px">加载失败</span>
        <a-tooltip :title="'重新加载'+v.label+'服务磁盘空间'" color="#2db7f5">
          <a-button type="primary" @click="reload(i)" shape="circle" size="small" :icon="h(RedoOutlined)"/>
        </a-tooltip>
      </a-descriptions-item>
    </template>
  </a-descriptions>
</template>

<script setup>
import api from "@/service/api"
import {axiosGet} from "@/layouts/admin-sidebar/requstDev"
import load from "@/common/load"
import {h, ref} from "vue";
import {RedoOutlined} from "@ant-design/icons-vue";

// 定义正则表达式来匹配括号中的百分比数字
let regeNumber = /\(([\d.]+)%\)/;
// MQTTServerSpace  MQTT服务空间
let dataServer = ref({
  MQTTServerSpace: {
    free: "",
    used: "",
    total: "",
    label: "MQTT",
    status: true,
    color: "#fdc0cc"
  },
  MAPServerSpace: {
    free: "",
    used: "",
    total: "",
    label: "地图",
    status: true,
    color: "#98030d"
  },
  MEDIAServerSpace: {
    free: "",
    used: "",
    total: "",
    label: "媒体",
    status: true,
    color: "#080d98"
  }
})
// 获取返回内容里面的数值
let regex = /<span[^>]*>(.*?)<\/span>/g;

let requstServer = async (url, data) => {
  try {
    load.loading(`正在加载磁盘空间...`);
    let result = await axiosGet(url);
    if (result && result.code !== 0) {
      let arr = [];
      let matches;
      while ((matches = regex.exec(result)) !== null) {
        arr.push(matches[1]); // 使用第一个捕获组的内容
      }
      dataServer.value[data].free = arr[0];
      dataServer.value[data].used = arr[1];
      dataServer.value[data].total = arr[2];
      dataServer.value[data].status = false;
    } else {
      load.error(`加载${dataServer.value[data].label}服务磁盘空间失败...`)
    }
  } catch (e) {
    load.error(`加载${dataServer.value[data].label}服务磁盘空间失败...`)
  }
}
let initDisk = ()=>{
  // 加载三个服务磁盘空间
  requstServer(api.MQTTSERVERURL, 'MQTTServerSpace')
  requstServer(api.MAPSERVERURL, 'MAPServerSpace')
  requstServer(api.MEDIASERVERURL, 'MEDIAServerSpace')
}
initDisk();
// 重新加载
let reload = (data) => {
  if (data === 'MQTTServerSpace') {
    requstServer(api.MQTTSERVERURL, 'MQTTServerSpace')
  } else if (data === 'MAPServerSpace') {
    requstServer(api.MAPSERVERURL, 'MAPServerSpace')
  } else if (data === 'MEDIAServerSpace') {
    requstServer(api.MEDIASERVERURL, 'MEDIAServerSpace')
  }
}
</script>
<style scoped lang="scss">

</style>
